'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { MotionAnimatedAutoHeight } from '@/components/ui/motion-animated-auto-height';
interface TradeFormTransitionProps {
  children: ReactNode;
  direction: 'buy' | 'sell' | 'swap';
  animateChanges: boolean;
  bare: boolean;
}
export function TradeFormTransition(t0) {
  const $ = _c(7);
  const {
    children,
    direction,
    animateChanges,
    bare
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== direction) {
    t1 = <div key={direction} className="flex w-full min-w-0 flex-col gap-3">{children}</div>;
    $[0] = children;
    $[1] = direction;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const content = t1;
  let t2;
  if ($[3] !== animateChanges || $[4] !== bare || $[5] !== content) {
    t2 = bare ? content : <MotionAnimatedAutoHeight animateChanges={animateChanges} className="min-w-0">{content}</MotionAnimatedAutoHeight>;
    $[3] = animateChanges;
    $[4] = bare;
    $[5] = content;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}